// @core/api/endpoints/task/toggle_checklist_item.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskResponse,
  ToggleChecklistItemRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Toggle checklist item
 * Toggles a checklist item between complete and incomplete states. Tracks who completed the item and when.
 */
export async function ToggleChecklistItem(
  task_id: string,
  checklist_id: string,
  item_id: string,
  data: ToggleChecklistItemRequest,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/checklists/:checklist_id/items/:item_id/toggle`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  requestPath = requestPath.replace(':checklist_id', encodeURIComponent(checklist_id));
  requestPath = requestPath.replace(':item_id', encodeURIComponent(item_id));
  const requestOptions = options;
  return client.post<TaskResponse>(requestPath, data, requestOptions);
}
